import React from 'react';
import { PhotoThumb } from '@/components/PhotoThumb';
import { DynamicField } from './DynamicField';
import type { FormSection } from '../types';

interface FormSectionRendererProps {
    section: FormSection;
    selectedAnimal?: any | null;
}

export function FormSectionRenderer({ section, selectedAnimal }: FormSectionRendererProps) {
    return (
        <div className="space-y-6">
            {/* Section Title */}
            {(section.label || section.title) && (
                <div className="mb-6">
                    <h2 className="text-2xl font-semibold text-foreground">
                        {section.label || section.title}
                    </h2>
                    {section.description && (
                        <p className="text-sm text-muted-foreground mt-2">
                            {section.description}
                        </p>
                    )}
                </div>
            )}

            {/* Animal Info Card - Only show in preferences section */}
            {selectedAnimal && (
                <div className="bg-muted/50 border rounded-lg p-4 mb-6">
                    <div className="flex gap-4">
                        {selectedAnimal.photos && selectedAnimal.photos.length > 0 && (
                            <PhotoThumb
                                src={`${import.meta.env.VITE_API_URL}${selectedAnimal.photos[0].url}`}
                                alt={selectedAnimal.name}
                                className="w-24 h-24 rounded-lg"
                            />
                        )}
                        <div className="flex-1">
                            <h3 className="font-semibold text-lg">{selectedAnimal.name}</h3>
                            <p className="text-sm text-muted-foreground">
                                Estás adoptando a este animal. Las preferencias se han completado automáticamente con sus datos.
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Fields */}
            {section.fields.map((field) => (
                <DynamicField key={field.id} field={field} />
            ))}
        </div>
    );
}
